export class AppEnvironment {
    public static readonly Production: string = "Production";
    public static readonly Test: string = "Test";
    public static readonly Dev: string = "Dev";
    public static readonly Local: string = "Local";
}